var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/helpers/extends", "react", "prop-types", "classnames", "../../propTypes", "../../UI/Interchange/Interchange", "../../UI/Icon/Icon", "../../css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/helpers/extends"), require("react"), require("prop-types"), require("classnames"), require("../../propTypes"), require("../../UI/Interchange/Interchange"), require("../../UI/Icon/Icon"), require("../../css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.react, global.propTypes, global.classnames, global.propTypes, global.Interchange, global.Icon, global.css);
    global.TeaserSubscribe = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _react, _propTypes, _classnames, _propTypes2, _Interchange, _Icon, _css) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _propTypes2 = _interopRequireDefault(_propTypes2);
  _Interchange = _interopRequireDefault(_Interchange);
  _Icon = _interopRequireDefault(_Icon);

  var TeaserSubscribe = function TeaserSubscribe(_ref) {
    var breakpointFormat = _ref.breakpointFormat,
        className = _ref.className,
        id = _ref.id,
        images = _ref.images,
        labels = _ref.labels,
        onTeaserClick = _ref.onTeaserClick,
        selected = _ref.selected,
        subtitle = _ref.subtitle,
        title = _ref.title;
    var iconName = selected ? 'arte-next-subscribed' : 'arte-next-not-subscribed';
    var iconTitle = selected ? labels.unsubscribe : labels.subscribe;
    var teaserAttributes = {
      'aria-checked': selected
    };
    return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
      className: (0, _classnames.default)('next-teaser-subscribe', className, {
        'is-selected': selected
      }),
      onClick: function onClick(evt) {
        return onTeaserClick(id, evt);
      },
      onKeyDown: function onKeyDown(evt) {
        if (evt.keyCode === 13 || evt.keyCode === 32) {
          evt.preventDefault(); // prevent scroll when clicking on spacebar

          onTeaserClick(id, evt);
        }
      },
      role: "checkbox",
      tabIndex: "0"
    }, teaserAttributes), /*#__PURE__*/_react.default.createElement(_Interchange.default, {
      hover: _css.hovers.subscribe,
      images: images,
      title: title,
      breakpointFormat: breakpointFormat
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: "next-teaser-subscribe__icon",
      name: iconName,
      size: "custom",
      title: iconTitle
    })), /*#__PURE__*/_react.default.createElement("h3", {
      className: "next-teaser-subscribe__title"
    }, title, title && subtitle ? ' - ' : '', subtitle));
  };

  TeaserSubscribe.propTypes = {
    breakpointFormat: _propTypes.default.shape(),
    className: _propTypes.default.string,
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    images: _propTypes.default.arrayOf(_propTypes2.default.image).isRequired,
    labels: _propTypes.default.shape({
      subscribe: _propTypes.default.string,
      unsubscribe: _propTypes.default.string
    }),
    onTeaserClick: _propTypes.default.func,
    selected: _propTypes.default.bool,
    subtitle: _propTypes.default.string,
    title: _propTypes.default.string.isRequired
  };
  TeaserSubscribe.defaultProps = {
    breakpointFormat: _propTypes2.default.breakpointFormat,
    className: '',
    labels: {
      subscribe: '',
      unsubscribe: ''
    },
    onTeaserClick: function onTeaserClick() {},
    selected: false
  };
  var _default = TeaserSubscribe;
  _exports.default = _default;
});